import React from "react";
import Marquee from "react-fast-marquee";
import { Typography, Card, Row, Col, Carousel } from "antd";

import BrandLogo1 from "../../../../assets/seller/icons/brand-logo-1.png";
import BrandLogo2 from "../../../../assets/seller/icons/brand-logo-2.svg";
import BrandLogo3 from "../../../../assets/seller/icons/brand-logo-3.svg";
import BrandLogo4 from "../../../../assets/seller/icons/brand-logo-4.svg";
import BrandLogo5 from "../../../../assets/seller/icons/brand-logo-5.svg";
import BrandLogo6 from "../../../../assets/seller/icons/brand-logo-6.svg";
import BrandLogo7 from "../../../../assets/seller/icons/brand-logo-7.svg";
import BrandLogo8 from "../../../../assets/seller/icons/philips-logo.svg";
import BrandLogo9 from "../../../../assets/seller/icons/brand-logo-9.svg";
import BrandLogo10 from "../../../../assets/seller/icons/brand-logo-10.svg";
import BrandLogo11 from "../../../../assets/seller/icons/centuryplay-logo.svg";
import BrandLogo12 from "../../../../assets/seller/icons/brand-logo-12.svg";

import HidecorLogo from "../../../../assets/seller/icons/hidecor.webp";
import YaahviLogo from "../../../../assets/seller/icons/yahhvi.webp";
import sandharbhLogo from "../../../../assets/seller/icons/sandharbh.webp";
import MysankalpLogo from "../../../../assets/seller/icons/mysankalp.webp";
import MysankalpAuthorLogo from "../../../../assets/seller/icons/mysankalp_author.webp";
import HidecoreAuthorLogo from "../../../../assets/seller/icons/hidecor_author.webp";
import yashviauthorLogo from "../../../../assets/seller/icons/yashviauthor.webp";
import SandarbauthorLogo from "../../../../assets/seller/icons/sandarb_author.webp";

const Text = Typography;

const TESTIMONIALS_DATA = [
  {
    quote:
      "mobCREDIT has been a game-changer for our material procurement process. It streamlines cash flow, eliminates delays, and ensures seamless project execution. It’s an essential tool for any architect focused on efficiency.",
    author: "Anantha VR",
    position: "Hidecor",
    Logo: HidecorLogo,
    logoclass: "HidecorLogo",
    authorimage: HidecoreAuthorLogo,
    firmtype: "Interior Design firm",
  },
  {
    quote:
      "mobCREDIT has simplified the process, eliminating the hassle of constantly requesting credit from suppliers. Now, we focus on what matters most—building! Highly recommend it!",
    author: "Sankalp Solanki",
    position: "My Sankalp",
    Logo: MysankalpLogo,
    logoclass: "MysankalpLogo",
    authorimage: MysankalpAuthorLogo,
    firmtype: "Home & Office Construction",
  },
  {
    quote:
      "Initially, we didn’t think we needed it, but mobCREDIT has greatly simplified payments and boosted supplier trust. With broader adoption by suppliers, it will ease procurement.",
    author: "Amith Shetty",
    position: "Yaahvi Homes",
    Logo: YaahviLogo,
    logoclass: "YaahviLogo",
    authorimage: yashviauthorLogo,
    firmtype: "Construction & Interior firm",
  },
  {
    quote:
      "Each transaction is securely authorised via OTP, giving us control and peace of mind. Ability to use this with independent suppliers is excellent. No more sudden follow ups from the suppliers for repayments.",
    author: "Sairaam Rai",
    position: "Sandarbh Design Studio",
    Logo: sandharbhLogo,
    logoclass: "sandharbhLogo",
    authorimage: SandarbauthorLogo,
    firmtype: "Home & Office Construction",
  },
];

const TestimonialsSection = React.memo(() => (
  <>
    <section className="wow fadeInUp main-common-padding" style={{ backgroundColor: "white" }}>
      <div className="container" style={{ margin: "0 auto" }}>
        <h2 className="txt-font-bigger">Hear what your clients have to say</h2>
        <Carousel touchDraggable={true} dotPosition="bottom" slidesToShow={1} slidesToScroll={1} initialSlide={1} style={{ textAlign: "left" }} className="d-block d-sm-block d-lg-none d-xl-none">
          {TESTIMONIALS_DATA.map((testimonial, index) => (
            <div key={index}>
              <Card className="card-testimonial text-left bg-testimonial">
                <Row className="d-flex" style={{ alignItems: "center", justifyContent: "space-between" }}>
                  <Col className="p-0"><img src={testimonial.Logo} alt={testimonial.Logo} className={testimonial.logoclass} /></Col>
                  <Col><Text className="testimonial-badge">{testimonial.firmtype}</Text></Col>
                </Row>
                <Row>
                  <Col className="p-0 mt-2">
                    <Col style={{ height: "110px" }}><Text className="font-italic">{testimonial.quote}</Text></Col>
                    <Col className="d-flex mt-4" style={{ gap: "10px", alignItems: "center" }}>
                      <Col><img src={testimonial.authorimage} alt={testimonial.authorimage} /></Col>
                      <Col style={{ marginTop: "8px" }}>
                        <Typography.Title className="authorname" level={5}>{testimonial.author}</Typography.Title>
                        <Typography.Text className="font-italic" style={{ marginTop: "-10px" }}>{testimonial.position}</Typography.Text>
                      </Col>
                    </Col>
                  </Col>
                </Row>
              </Card>
            </div>
          ))}
        </Carousel>
        <Carousel touchDraggable={true} dotPosition="bottom" slidesToShow={2} slidesToScroll={1} initialSlide={1} style={{ textAlign: "left" }} className="d-none d-md-none d-lg-block d-xl-block">
          {TESTIMONIALS_DATA.map((testimonial, index) => (
            <div key={index}>
              <Card className="card-testimonial text-left bg-testimonial">
                <Row className="d-flex" style={{ alignItems: "center", justifyContent: "space-between" }}>
                  <Col className="p-0"><img src={testimonial.Logo} alt={testimonial.Logo} className={testimonial.logoclass} /></Col>
                  <Col><Text className="testimonial-badge">{testimonial.firmtype}</Text></Col>
                </Row>
                <Row>
                  <Col className="p-0 mt-2">
                    <Col style={{ height: "110px" }}><Text className="font-italic">{testimonial.quote}</Text></Col>
                    <Col className="d-flex mt-4" style={{ gap: "10px", alignItems: "center" }}>
                      <Col><img src={testimonial.authorimage} alt={testimonial.authorimage} /></Col>
                      <Col style={{ marginTop: "8px" }}>
                        <Typography.Title className="authorname" level={5}>{testimonial.author}</Typography.Title>
                        <Typography.Text className="font-italic" style={{ marginTop: "-10px" }}>{testimonial.position}</Typography.Text>
                      </Col>
                    </Col>
                  </Col>
                </Row>
              </Card>
            </div>
          ))}
        </Carousel>
      </div>
    </section>
    <section>
      <div className="container" style={{ margin: "0 auto", marginBottom: "40px", marginTop: "20px" }}>
        <h2 className="txt-font-bigger">All major brands SKUs</h2>
        <Marquee autoFill={true}>
          <img src={BrandLogo1} alt="Brand logo 1" className="marquee-img" />
          <img src={BrandLogo2} alt="Brand logo 7" className="marquee-img" />
          <img src={BrandLogo3} alt="Brand logo 1" className="marquee-img" />
          <img src={BrandLogo4} alt="Brand logo 7" className="marquee-img" />
          <img src={BrandLogo5} alt="Brand logo 1" className="marquee-img" />
          <img src={BrandLogo6} alt="Brand logo 7" className="marquee-img" />
          <img src={BrandLogo7} alt="Brand logo 1" className="marquee-img" />
          <img src={BrandLogo8} alt="Brand logo 7" className="marquee-img" />
          <img src={BrandLogo9} alt="Brand logo 1" className="marquee-img" />
          <img src={BrandLogo10} alt="Brand logo 7" className="marquee-img" />
          <img src={BrandLogo11} alt="Brand logo 7" className="marquee-img" />
          <img src={BrandLogo12} alt="Brand logo 7" className="marquee-img" />
        </Marquee>
      </div>
    </section>
  </>
));

export default TestimonialsSection;
